const ToCart = ({ data, showIcon }) => {
  const { inStock, inCart, toCart } = data;

  return (
    <>
      {inStock && inCart === undefined && (
        <button className="btn" onClick={toCart}>
          <span>В корзину</span>
          {showIcon && <img src="/static/img/icons/buy.svg" alt="cart" />}
        </button>
      )}
      {inStock && inCart !== undefined && (
        <button
          className="btn in-cart"
          onClick={() => (window.location.href = '/cart')}
        >
          <span>В корзине</span>
          {showIcon && <img src="/static/img/icons/buy.svg" alt="cart" />}
        </button>
      )}
      {!inStock && inCart === undefined && (
        <button className="btn" onClick={toCart}>
          <span>Под заказ</span>
          {showIcon && <img src="/static/img/icons/buy.svg" alt="cart" />}
        </button>
      )}
      {!inStock && inCart !== undefined && (
        <button
          className="btn in-cart"
          onClick={() => (window.location.href = '/cart')}
        >
          <span>В корзине</span>
          {showIcon && <img src="/static/img/icons/buy.svg" alt="cart" />}
        </button>
      )}
    </>
  );
};

export default ToCart;
